import { render } from "./QSearch.vue?vue&type=template&id=61037d2e&scoped=true"
import script from "./QSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./QSearch.vue?vue&type=script&setup=true&lang=js"

import "./QSearch.vue?vue&type=style&index=0&id=61037d2e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61037d2e"],['__file',"src/components/UI/inputs/QSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61037d2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61037d2e', __exports__)) {
    api.reload('61037d2e', __exports__)
  }
  
  module.hot.accept("./QSearch.vue?vue&type=template&id=61037d2e&scoped=true", () => {
    api.rerender('61037d2e', render)
  })

}


export default __exports__